import { render, staticRenderFns } from "./CaLogo.vue?vue&type=template&id=45281b8e&scoped=true&"
import script from "./CaLogo.vue?vue&type=script&lang=ts&"
export * from "./CaLogo.vue?vue&type=script&lang=ts&"
function injectStyles (context) {
  
  var style0 = require("./CaLogo.vue?vue&type=style&index=0&id=45281b8e&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "45281b8e",
  null
  ,true
)

export default component.exports